import { notSelectedValue } from "@pages/shops/[uuid]/request_reservation";
import { Text } from "@components/Text";
import { ReservationFormRow } from "@components/pages/shops/[uuid]/request_reservation/ReservationFormRow";
import { ReservationFormSelect } from "@components/pages/shops/[uuid]/request_reservation/ReservationFormSelect";
import { toJpTime } from "@libs/utils/date";
import styles from "./index.module.css";
import type { RequestReservation_ReservationFramesByDateOrMatchQuery } from "@pages/shops/[uuid]/request_reservation/__generated__/queries";
import type { FC } from "react";

type ReservationFrameType =
  | RequestReservation_ReservationFramesByDateOrMatchQuery["reservationFramesByDateOrMatch"][0]
  | undefined;

type Props = {
  reservationFrame: ReservationFrameType;
  showNote: boolean;
};

const formatTimeOption = (
  reservationFrame: ReservationFrameType,
  timeOption: string
) => {
  const matchStartsAtForTimeOption = reservationFrame?.matchStartsAt;
  const slicedTimeOption =
    timeOption[0] === "0" ? timeOption.slice(1, timeOption.length) : timeOption;
  if (
    matchStartsAtForTimeOption &&
    toJpTime(matchStartsAtForTimeOption) === slicedTimeOption
  ) {
    const actualMatchStartsAt = reservationFrame?.match?.startsAt;
    const suffix =
      actualMatchStartsAt && actualMatchStartsAt !== matchStartsAtForTimeOption
        ? `試合開始(${toJpTime(actualMatchStartsAt)})`
        : "試合開始";
    return `${slicedTimeOption} ${suffix}`;
  }
  return slicedTimeOption;
};

export const ReservationComesAtRow: FC<Props> = ({
  reservationFrame,
  showNote,
}) => {
  const timeOptions = reservationFrame?.timeOptions ?? [];

  return (
    <ReservationFormRow title="来店時間">
      <ReservationFormSelect name={"comesAt"} required={true}>
        <option value={notSelectedValue} disabled>
          選択してください
        </option>
        {timeOptions.map((t) => (
          <option key={t} value={t}>
            {formatTimeOption(reservationFrame, t)}
          </option>
        ))}
      </ReservationFormSelect>
      {showNote && (
        <Text size={12} className={styles.note}>
          試合上映がある場合、試合開始時間の1時間前から2時間後はご予約できません。
        </Text>
      )}
    </ReservationFormRow>
  );
};
